// @flow
import type { Element } from 'react';

import React, { Fragment } from 'react';
import { Button, Table } from 'reactstrap';
import {
  OCCUPANCY_BY_STORY_LOCATION_SPECIFIER,
  OCCUPANCY_BY_STORY_OCCUPANCY,
} from '@hbrisk/sp3-risk-model-support/models/app/attributes/names/index.js';
import { normalizeLocationSpecifierTokens } from '@hbrisk/sp3-risk-model-support/models/locationSpecifier/index.js';
import GridField from '#components/pages/Models/Model/sections/support/forms/GridField/index.jsx';
import Tip from '#components/support/tooltips/Tip/index.jsx';
import OccupancySelectMenu from '../OccupancySelectMenu/index.jsx';

type Props = {|
  form: string,
  fields: {
    length: number,
    map: Function,
    push: Function,
    remove: Function,
  },
  meta: { error: string },
|};

const renderOccupancyByStory = ({ form, fields, meta }: Props): Element<typeof Fragment> => {
  const { error } = meta;
  const allowDelete = fields.length > 1 || false;
  const occupancyByStoryRows = fields.map((field, index) => (
    <tr key={field}>
      <td>
        <GridField
          name={`${field}.${OCCUPANCY_BY_STORY_LOCATION_SPECIFIER}`}
          form={form}
          options={{
            ComponentType: 'text',
            includeFormatting: false,
            format: normalizeLocationSpecifierTokens,
            normalize: normalizeLocationSpecifierTokens,
          }}
        />
      </td>
      <td>
        <GridField
          name={`${field}.${OCCUPANCY_BY_STORY_OCCUPANCY}`}
          form={form}
          options={{
            ComponentType: OccupancySelectMenu,
            includeFormatting: false,
          }}
        />
      </td>
      <td>
        <Button color="link" onClick={() => fields.remove(index)} disabled={!allowDelete}>
          delete
        </Button>
      </td>
    </tr>
  ));
  return (
    <>
      <Table responsive className="occupancy-by-story-table">
        <thead>
          <tr>
            <th>
              Stories <Tip tipId="story" />
            </th>
            <th>
              Occupancy <Tip tipId="occupancyByStoryOccupancy" />
            </th>
          </tr>
        </thead>
        <tbody>{occupancyByStoryRows}</tbody>
      </Table>
      {error && <div className="text-danger">{error}</div>}
      <Button
        size="sm"
        id="addOccupancyRowButton"
        className="float-right"
        color="primary"
        onClick={() => fields.push({})}
      >
        Add Row
      </Button>
    </>
  );
};

export default renderOccupancyByStory;
